<!--
@component
@deprecated Use `TabMenu.svelte` instead. This component will be removed once all usages are migrated.
-->
<script lang="ts">
	import { DefaultRobotoFontProps, type FontProps, getFontPropsVarString } from '$types/fontProps'

	export let active: boolean
	export let disabled: boolean = false
	export let label: string // potentially html allowed
	export let fontProps: FontProps = DefaultRobotoFontProps(
		'normal',
		'1.25rem',
		'#9d9d9d',
		'black',
		400
	)
	$: fontPropsStyleString = getFontPropsVarString(fontProps)
</script>

<li class:active class:disabled title={label} style={fontPropsStyleString} on:click>
	{@html label}
	<!-- underline slides in via css transition when this tab becomes active -->
	<div class="underline" class:active></div>
</li>

<style lang="scss">
	@import '$styles/global';

	li {
		@include roboto-font(var(--line-height), var(--font-weight), var(--font-size), var(--color));
		@include flex-row($justify: space-between);

		margin: 0;
		padding: 10px 15px;
		border-radius: 5px 5px 0 0;
		width: 100%;
		position: relative;
		background: white;
		height: 100%;
		flex: 1;
		user-select: none;
		list-style: none;
		cursor: pointer;

		&.disabled {
			color: $grey-700;
			cursor: not-allowed;
		}

		&.active {
			color: $primaryGreen;
		}
	}

	div.underline {
		position: absolute;
		bottom: -2px;
		left: 9px;
		right: 9px;
		height: 3px;
		background: $primaryGreen;
		border-radius: 3px;
		// collapsed and hidden until the tab is active; grows in from the centre
		transform: scaleX(0);
		opacity: 0;
		// slide-like feel without an animation library
		transition:
			transform 0.2s ease,
			opacity 0.2s ease;

		&.active {
			transform: scaleX(1);
			opacity: 1;
		}
	}
</style>
